import { useTranslation } from "react-i18next";
import type { Locale } from "@nh/shared";
import { TextField } from "@/shared/ui/core";
import { TextAreaField } from "@/features/admin/components";

export interface PackageContentFieldsProps {
  locale: Locale;
  /** El español es obligatorio; el inglés no. */
  required: boolean;
}

/**
 * El contenido del paquete en UN idioma.
 *
 * Los nombres de los campos son la ruta del contrato
 * (`translations.es.name`), no un nombre plano: así lo que el formulario
 * produce ya tiene la forma que el API espera, y cuando el contrato
 * rechaza algo el error aterriza en el campo exacto.
 *
 * Las ETIQUETAS van en el idioma de la interfaz, no en el del contenido:
 * quien administra en español escribiendo el paquete en inglés sigue
 * leyendo "Nombre". El idioma que se está editando lo dice la pestaña,
 * que es donde se decidió.
 */
export function PackageContentFields({ locale, required }: PackageContentFieldsProps) {
  const { t } = useTranslation();

  return (
    <>
      <TextField
        name={`translations.${locale}.name`}
        label={t("Nombre")}
        required={required}
        placeholder={t("Paquete Bienestar")}
        fieldClassName="sm:col-span-2"
      />

      <TextField
        name={`translations.${locale}.tagline`}
        label={t("Eslogan")}
        hint={t("Una línea corta, debajo del nombre.")}
        fieldClassName="sm:col-span-2"
      />

      <TextAreaField
        name={`translations.${locale}.description`}
        label={t("Descripción")}
        rows={5}
        hint={t("Qué trae el paquete y para quién es.")}
        fieldClassName="sm:col-span-2"
      />
    </>
  );
}
